import { render, staticRenderFns } from "./UpdateCaddy.vue?vue&type=template&id=2d133f79"
import script from "./UpdateCaddy.vue?vue&type=script&lang=js"
export * from "./UpdateCaddy.vue?vue&type=script&lang=js"
import style0 from "./UpdateCaddy.vue?vue&type=style&index=0&id=2d133f79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports